// extracted by mini-css-extract-plugin
export default {"dropdown":"NewPlayer_dropdown__uzxKd","actions":"NewPlayer_actions__TGsN8","error":"NewPlayer_error__gBSJ8"};